/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1ClassroomdisciplineIdSlidesSlideidDownloadUrl200,
  GetApiV1ClassroomdisciplineIdSlidesSlideidDownloadUrl400,
  GetApiV1ClassroomdisciplineIdSlidesSlideidDownloadUrl401,
  GetApiV1ClassroomdisciplineIdSlidesSlideidDownloadUrl404,
  GetApiV1ClassroomdisciplineIdSlidesSlideidDownloadUrlPathParams,
  GetApiV1ClassroomdisciplineIdSlidesSlideidDownloadUrlQueryResponse,
} from "../../types/classPlanningMaterialController/GetApiV1ClassroomdisciplineIdSlidesSlideidDownloadUrl.ts";
import { materialDownloadUrlViewModelSchema } from "../materialDownloadUrlViewModelSchema.ts";

export const getApiV1ClassroomdisciplineIdSlidesSlideidDownloadUrlPathParamsSchema =
  z.object({
    id: z.coerce.number().int(),
    slideId: z.coerce.number().int(),
  }) as unknown as ToZod<GetApiV1ClassroomdisciplineIdSlidesSlideidDownloadUrlPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1ClassroomdisciplineIdSlidesSlideidDownloadUrl200Schema =
  z.lazy(
    () => materialDownloadUrlViewModelSchema,
  ) as unknown as ToZod<GetApiV1ClassroomdisciplineIdSlidesSlideidDownloadUrl200>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const getApiV1ClassroomdisciplineIdSlidesSlideidDownloadUrl400Schema =
  z.any() as unknown as ToZod<GetApiV1ClassroomdisciplineIdSlidesSlideidDownloadUrl400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1ClassroomdisciplineIdSlidesSlideidDownloadUrl401Schema =
  z.any() as unknown as ToZod<GetApiV1ClassroomdisciplineIdSlidesSlideidDownloadUrl401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1ClassroomdisciplineIdSlidesSlideidDownloadUrl404Schema =
  z.any() as unknown as ToZod<GetApiV1ClassroomdisciplineIdSlidesSlideidDownloadUrl404>;

export const getApiV1ClassroomdisciplineIdSlidesSlideidDownloadUrlQueryResponseSchema =
  z.lazy(
    () => getApiV1ClassroomdisciplineIdSlidesSlideidDownloadUrl200Schema,
  ) as unknown as ToZod<GetApiV1ClassroomdisciplineIdSlidesSlideidDownloadUrlQueryResponse>;
